import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import CustomTabs from "@/components/custom/custom-tabs";

const tabs = [
  { name: "Chargebacks", path: "/disputes/chargebacks" },
  { name: "Complaints", path: "/disputes/complaints" },
];

const DisputeOutlet = () => (
  <Box>
    <CustomTabs tabs={tabs} variant="pill" sx={{ m: 2, mb: 0 }} />
    <Outlet />
  </Box>
);

export default DisputeOutlet;
